/**
 * Ordered multi-select for Telephony IP / Media servers.
 * First selected = Primary; others = Failover backups.
 */
export default function FailoverServerMultiSelect({
  servers = [],
  selectedIds = [],
  onChange,
  testid,
  emptyText = "No servers assigned to this account.",
  className = "",
}) {
  const selected = Array.isArray(selectedIds) ? selectedIds : [];

  const toggle = (id, checked) => {
    const cur = [...selected];
    const next = checked
      ? (cur.includes(id) ? cur : [...cur, id])
      : cur.filter((x) => x !== id);
    onChange(next);
  };

  return (
    <div
      className={`rounded-md border bg-white p-2.5 max-h-36 overflow-y-auto space-y-1.5 ${className}`}
      data-testid={testid}
    >
      {servers.map((s) => {
        const on = selected.includes(s.id);
        const order = selected.indexOf(s.id);
        return (
          <label key={s.id} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              data-testid={`${testid}-option-${s.id}`}
              checked={on}
              onChange={(e) => toggle(s.id, e.target.checked)}
            />
            <span className="truncate min-w-0">
              {s.name}{s.is_default ? " (default)" : ""} · {s.host || ""}
            </span>
            {order === 0 && (
              <span className="text-[10px] uppercase tracking-wide text-muted-foreground shrink-0">
                Primary
              </span>
            )}
            {order > 0 && (
              <span className="text-[10px] uppercase tracking-wide text-muted-foreground shrink-0">
                Failover {order + 1}
              </span>
            )}
          </label>
        );
      })}
      {servers.length === 0 && (
        <p className="text-xs text-destructive">{emptyText}</p>
      )}
    </div>
  );
}
